import React, { useContext, useState, useEffect, useRef } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/react-hooks';
// import { ReactEpubViewer } from 'react-epub-viewer';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import { ReactReader } from "react-reader";
import { withTranslation } from 'react-i18next';
import StarsRating from 'stars-rating';
import { Divider, Button, Icon, Grid, Modal, Image, TextArea, Popup } from 'semantic-ui-react';
import { store } from 'react-notifications-component';
import moment from 'moment';
import { motion } from 'framer-motion';

//@Custom Component
import MainHeader from '../components/MainHeader/MainHeader';
import Spinner from '../common/Spinner';
import { AuthContext } from '../context/auth';
import Footer from '../components/Footer';

// @Icons
import { VscBook, VscCloseAll, VscTag } from 'react-icons/vsc';
import { FaRegUserCircle } from 'react-icons/fa';
import { MdMoneyOff, MdOndemandVideo, MdRateReview } from 'react-icons/md';
import { AiOutlineDollarCircle, AiOutlineFundView, AiOutlineSound } from 'react-icons/ai';
import { RiAddBoxLine, RiDeleteBin4Line, RiEditBoxLine, RiFacebookCircleLine, RiFeedbackLine, RiMailSendLine, RiTwitterLine, RiWhatsappLine} from 'react-icons/ri';

//@Styles
import 'react-notifications-component/dist/theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';

//@Graphql Queries and Mutations
import { CREATE_CART_BOOK, DELETE_BOOK, RATE_BOOK, REPORT_BOOK } from '../graphql/mutation';
import { FETCH_ALL_APPLOVED_BOOKS, FETCH_ALL_BOOKS_IN_MY_CART, FETCH_ALL_BOOK_REVIEWS, FETCH_AVERAGE_RATE, FETCH_ONE_BOOK } from '../graphql/query';

//@Constants and utils functions
import { mailClick, whatsappClick, facebookClick, twitterClick } from '../utils/socialMedia';
import lang from '../utils/translations';
import DEFAULT_IMAGE from '../assets/default_Images/default_Image.jpg';
import PROFILE_IMAGE from '../assets/profile.png';
import AudioPlayer from '../components/Player/AudioPlayer';
import VideoPlayer from '../components/Player/VideoPlayer';
import { ToastFailureMessage, ToastSuccessMessage } from '../common/ToastMessages';
// import capitalize from 'lodash/capitalize';
import LoadingViewer from '../common/LoadingViewer';
import ErrorViewer from '../common/ErrorViewer';
import { ContentCard } from '../components/ContentCard';
import { onNextHandler, onPreviousHandler } from '../utils';
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from 'react-icons/io';

function SingleOneBook(props) {
  const history = useHistory();
  const ArrowIconRef = useRef();
  const BottomArrowIconRef = useRef();
  // const viewerRef = useRef(null);

  const [location, setLocation] = useState(null)
  const locationChanged = (epubcifi) => {
    // epubcifi is a internal string used by epubjs to point to a location in an epub. It looks like this: epubcfi(/6/6[titlepage]!/4/2/12[pgepubid00003]/3:0)
    setLocation(epubcifi)
  }

  const [isPlayingAudio, setIsPlayingAudio] = useState(false);
  const audioPlayerRef = useRef();

  const [openVideoModal, setOpenVideoModal] = useState(false);

  const [bookId, setBookId] = useState(0);
  const [redirect, setRedirect] = useState(false);
  const [errors, setErrors] = useState(null);
  const [open, setOpen] = useState(false);
  const [openBook, setOpenBook] = useState(false);
  const [openBookSummary, setOpenBookSummary] = useState(false);
  const close = () => setOpen(false);

  const [openReport, setReportOpen] = useState(false);
  const closeReport = () => setReportOpen(false);
  const [openRating, setOpenRating] = useState(false);
  const closeRating = () => setOpenRating(false);

  const [openReview, setOpenReview] = useState(false);
  const closeReview = () => setOpenReview(false);

  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [ratingValues, setRatingValues] = useState({ ratingValue: '', review: '', slug: props.match.params.slug });

  const onChangeRating = e => setRatingValues({ ...ratingValues, [e.target.name]: e.target.value });

  const onClickDelete = () => {
    deleteBookInfo();
    history.push('/');
  };

  const { user } = useContext(AuthContext);
  const { loading, error, data, refetch } = useQuery(FETCH_ONE_BOOK, { variables: { slug: props.match.params.slug } });
  const { data: approvedBooks } = useQuery(FETCH_ALL_APPLOVED_BOOKS, { variables: { limit: 62, action: 'Next' } });

  const [values, setValues] = useState({
    bookId: '',
    description: 'This content is not respected HAAPA terms and conditions. Maybe it is spam!',
  });

  const [cartCreate] = useMutation(CREATE_CART_BOOK, {
    update(_cache, _result) {
      ToastSuccessMessage('contents added to your cart!');
      history.push(`/contents/cart/${user.username || user.user.username}`);
    },
    onError(err) {
      if (err.graphQLErrors.length > 0) {
        let onerr = err.graphQLErrors[0].message.split(',');
        setErrors(onerr);
        ToastFailureMessage(onerr[0]);
        setErrors(null);
      }
    },
    variables: {
      ...values,
      bookId: bookId !== 0 ? parseInt(bookId) : parseInt(values.bookId),
    },
    context: {
      headers: {
        authorization: localStorage.getItem('token'),
      },
    },
    refetchQueries: [{ query: FETCH_ALL_BOOKS_IN_MY_CART }],
    awaitRefetchQueries: true,
  });

  const onChangeHandle = e => setValues({ ...values, [e.target.name]: e.target.value });

  // eslint-disable-next-line
  const [createReport, { loading: spin }] = useMutation(REPORT_BOOK, {
    update(cache, result) {
      store.addNotification({
        title: 'Success',
        message: 'Content reported successfully!',
        type: 'success',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: { duration: 5000, onScreen: true },
      });
    },
    onError(err) {
      if (err.graphQLErrors.length > 0) {
        let onerr = err.graphQLErrors[0].message.split(',');
        setErrors(onerr);
        store.addNotification({
          title: 'Warning',
          message: onerr[0],
          type: 'warning',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animated', 'fadeIn'],
          animationOut: ['animated', 'fadeOut'],
          dismiss: { duration: 5000, onScreen: true },
        });
      }
    },
    variables: {
      ...values,
      bookId: parseInt(values.bookId),
      description: values.description,
    },
    context: {
      headers: {
        authorization: localStorage.getItem('token'),
      },
    },
  });

  function onSubmitHandle() {
    if (user) {
      return cartCreate();
    } else {
      setRedirect(true);
    }
  }

  function onReportBook() {
    if (!user) {
      setRedirect(true);
    } else {
      createReport();
      setReportOpen(false);
    }
  }

  const [deleteBook, { loading: DeleteLoading }] = useMutation(DELETE_BOOK, {
    update(proxy, { data }) {
      ToastSuccessMessage(data?.deleteBook?.message);
      history.push(`/`);
    },
    onError(err) {
      if (err.graphQLErrors.length > 0) {
        let onerr = err.graphQLErrors[0].message.split(',');
        setErrors(onerr);
      }
    },
    variables: {
      slug: props.match.params.slug,
    },
    context: {
      headers: {
        authorization: localStorage.getItem('token'),
      },
    },
    refetchQueries: [{ query: FETCH_ALL_APPLOVED_BOOKS, variables: { limit: 62, action: 'Next' } }],
    awaitRefetchQueries: true,
  });

  function deleteBookInfo() {
    deleteBook();
  }

  function addBookToCart() {
    cartCreate();
    setErrors(null);
  }

  const onClickAddToCart = book_id => {
    if (!user) return history.push('/auth/login');
    setBookId(book_id);
    setErrors(null);
  };

  const [createRating, { loadingRating }] = useMutation(RATE_BOOK, {
    update(_proxy, { data }) {
      ToastSuccessMessage(data?.createRating?.message);
      history.push(`/contents/${slug}`);
    },
    onError(err) {
      if (err) {
        const onerr = err.graphQLErrors[0].message.split(',');
        setErrors(onerr);
      }
    },
    variables: {
      ...ratingValues,
      ratingValue: parseInt(rating),
      slug: props.match.params.slug,
    },
    context: {
      headers: {
        authorization: localStorage.getItem('token'),
      },
    },
  });

  const ratingStar = () => {
    if (!user) {
      setRedirect(true);
    } else if (rating <= 0) {
      store.addNotification({
        title: 'Error',
        message: 'Rating stars should be between 1 and 5 stars',
        type: 'danger',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: { duration: 5000, onScreen: true },
      });
    } else {
      createRating();
      setOpenRating(false);
    }
  };

  const { loading: loadingReviews, error: errorReviews, data: getBookReviews } = useQuery(FETCH_ALL_BOOK_REVIEWS, { variables: { slug: props.match.params.slug } });
  const { loading: loadingAverageRate, error: errorAverageRate, data: ratingAverage } = useQuery(FETCH_AVERAGE_RATE, { variables: { slug: props.match.params.slug } });
  const averageRate = !errorAverageRate && !loadingAverageRate && ratingAverage?.ratingAverage?.average;

  useEffect(() => {
    if (data) {
      setBookId(0);
      setValues({
        ...values,
        bookId: data.getOneBook.id,
      });
    }

    if (bookId > 0 && !errors) {
      addBookToCart();
      setBookId(0);
      setErrors(null);
    }

    // eslint-disable-next-line
  }, [data]);

  if (loading) return <LoadingViewer />;
  if (error) return <ErrorViewer msg={lang.t('Content not Found!')} />;

  if (history.location.state?.state === 'Updated') {
    refetch();
    history['location']['state'] = null;
  }
  const {
    books,
    coverUrl,
    audioUrl,
    videoUrl,
    bookUrl,
    hasAudioUrl,
    hasVideoUrl,
    hasBookUrl,
    name,
    userId,
    slug,
    bookCount,
    author,
    createdAt,
    summary,
    price,
    tags,
    createdBy: { profile, username },
  } = data.getOneBook;
  const url = window.location.toString();

  if (redirect) {
    return <Redirect to={{ pathname: '/auth/login', state: { from: props.location.pathname } }} />;
  }

  const isAllowedToReadBook = (hasBookUrl && bookUrl && price === 0) || (hasBookUrl && price > 0 && user && user.id === userId);
  const isAllowedToListenAudio = (hasAudioUrl && audioUrl && price === 0) || (hasAudioUrl && price > 0 && user && user.id === userId);
  const isAllowedToViewVideo = (hasVideoUrl && videoUrl && price === 0) || (hasVideoUrl && videoUrl && price > 0 && user && user.id === userId);

  const isEnabledToshowMore = summary.includes(' ') && summary.split(' ').length > 60;

  return (
    <>
      <MainHeader />
      <div className="container mt-7 user-select-none">
        <div className="row">
          <div className="col-lg-8 py-4">
            <div className="row">
              <div className="col-lg-6">
                <motion.img whileHover={{ scale: 1.1 }} src={coverUrl ? coverUrl : DEFAULT_IMAGE} alt="cover pic" className="image-cover-one" />
              </div>
              <div className="col-lg-6 py-auto">
                <div className="d-flex flex-column justify-content-between px-3" style={{ height: 440 }}>
                  <div className="col-lg-12 all-text-center">
                    <div className="py-2 d-flex all-text-center">
                      <StarsRating style={{ textAlign: 'center' }} count={5} size={20} color2={'#563636'} color1={'#ccc'} edit={false} value={averageRate || 0} />
                    </div>
                    <p className="fw-bold fs-4 mb-2 text-chocolate text-truncate all-text-center" data-toggle="tooltip" title={name} style={{ maxWidth: 310 }}>
                      {name}
                    </p>
                    <p className="d-flex align-items-center justify-content-start flex-nowrap all-text-center">
                      {price !== 0 ? (
                        <>
                          <AiOutlineDollarCircle className="me-1 text-chocolate" size={40} />
                          <span className="fw-bold fs-3 text-chocolate">{price}</span>
                        </>
                      ) : (
                        <>
                          <span className="fw-bold fs-3 text-chocolate">Free</span>
                          <MdMoneyOff className="me-1 text-chocolate" size={40} />
                        </>
                      )}
                    </p>

                    <p className="fw-light text-secondary text-truncate all-text-center" style={{ fontSize: 14 }}>
                      {lang.t('By')} {author}
                    </p>
                    <p className="fw-bold text-secondary all-text-center" style={{ fontSize: 14 }}>
                      {lang.t('Published')} {moment(createdAt).fromNow()}
                    </p>

                    <p className="text-summary all-text-center" style={{ fontSize: 14 }}>
                      {summary}
                    </p>
                    {isEnabledToshowMore && (
                      <Modal
                        centered={true}
                        size="small"
                        open={openBookSummary}
                        onClose={() => setOpenBookSummary(false)}
                        onOpen={() => setOpenBookSummary(true)}
                        trigger={
                          <button className="bg-white text-chocolate cursor-pointer fw-bold fs-6 py-2 px-3 all-text-center" style={{ border: '1px solid #563636' }}>
                            {lang.t('Read more')}
                          </button>
                        }
                      >
                        <div className="d-flex align-items-center justify-content-between p-3 bg-blue-darken m-0 shadow-sm">
                          <span className="fw-bold fs-5 text-white"> {name}</span>
                          <div data-toggle="tooltip" title="Close">
                            <VscCloseAll className="text-white cursor-pointer" size={30} onClick={() => setOpenBookSummary(false)} />
                          </div>
                        </div>
                        <div className="p-3 fw-lighter text-blue-darken fs-6" style={{ lineHeight: 1.5 }}>
                          {summary}
                        </div>
                      </Modal>
                    )}
                  </div>
                  <div className="d-flex flex-nowrap overflowX align-items-center justify-content-start all-text-center gap-2 py-2 hide-scrollbar" style={{ width: 310 }}>
                    {React.Children.toArray(
                      tags?.map(
                        ({ tagName }) =>
                          tagName.length >= 3 && (
                            <div className="d-flex align-items-center flex-nowrap text-center py-2 px-3 bg-chocolate text-white fw-light fs-6">
                              <VscTag className="text-white me-2" size={20} />
                              <span className="no-white-space">{tagName}</span>
                            </div>
                          ),
                      ),
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 py-4">
            <div className="d-flex flex-column justify-between  ps-3 pt-3 pe-3" style={{ height: 440 }}>
              <div>
                <div className="d-flex flex-column gap-2  pb-3">
                  <div className="d-flex flex-nowrap justify-content-start align-items-center p-3 gap-3 shadow">
                    <AiOutlineFundView size={50} className="text-chocolate" />
                    <div className="d-flex flex-column gap-2">
                      <span className="fs-4 fw-bold text-chocolate">{bookCount}</span>
                      <span className="fs-6 fw-light text-chocolate">{lang.t('Total Views')}</span>
                    </div>
                  </div>
                  <div className="d-flex flex-nowrap justify-content-start align-items-center p-3 gap-3 shadow" onClick={() => Boolean(getBookReviews?.getBookReviews.length) && setOpenReview(true)} style={{cursor:'pointer'}}>
                    <MdRateReview size={50} className="text-chocolate" />
                    <div className="d-flex flex-column gap-2">
                      <span className="fs-4 fw-bold text-chocolate">{getBookReviews?.getBookReviews.length ?? 0}</span>
                      <span className="fs-6 fw-light text-chocolate">{lang.t('Total Reviews')}</span>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-start flex-nowrap gap-2 pb-5">
                  <Button
                    animated="fade"
                    style={{ border: '2px solid #563636', borderRadius: 0, backgroundColor: '#563636', color: '#FFF', opacity: 1, width: '100%' }}
                    onClick={() => setOpenRating(true)}
                  >
                    <Button.Content visible>
                      <div className="d-flex align-items-center flex-nowrap justify-content-center">
                        {/* <RiAddBoxLine size={20} color="#FFF" /> */}
                        <span className="fw-bold fs-6 text-white ms-2">{lang.t('Add Review')}</span>
                      </div>
                    </Button.Content>
                    <Button.Content hidden>
                      <div className="d-flex align-items-center flex-nowrap justify-content-center">
                        <RiAddBoxLine size={20} color="#FFF" />
                        <span className="fw-bold fs-6 text-white ms-2">{lang.t('Write Your Review')}</span>
                      </div>
                    </Button.Content>
                  </Button>

                  <Button
                    animated="fade"
                    style={{ border: '2px solid #563636', borderRadius: 0, backgroundColor: '#563636', color: '#FFF', opacity: 1, width: '100%' }}
                    onClick={() => setReportOpen(true)}
                  >
                    <Button.Content visible>
                      <div className="d-flex align-items-center flex-nowrap justify-content-center">
                        {/* <RiFeedbackLine size={20} color="#FFF" /> */}
                        <span className="fw-bold fs-6 text-white ms-2">{lang.t('Report Book')}</span>
                      </div>
                    </Button.Content>
                    <Button.Content hidden>
                      <div className="d-flex align-items-center flex-nowrap justify-content-center">
                        <RiFeedbackLine size={20} color="#FFF" />
                        <span className="fw-bold fs-6 text-white ms-2">{lang.t('Report Book')}</span>
                      </div>
                    </Button.Content>
                  </Button>
                </div>
              </div>

              <div>
                <div className="d-flex flex-nowrap justify-content-between gap-5 p-3 mb-3 shadow">
                  <div className="d-flex align-items-center flex-column" data-toggle="tooltip" title={lang.t('Read book')}>
                    <span className={`fw-lighter fs-6 ${hasBookUrl ? 'text-chocolate' : 'text-grey'}`}>{lang.t('Read Here')}</span>
                    <VscBook size={60} color={hasBookUrl ? '#563636' : '#ccc'} style={{ cursor: 'pointer' }} onClick={() => isAllowedToReadBook && setOpenBook(true)} />
                    <span className={`fw-lighter fs-6 ${hasBookUrl ? 'text-chocolate' : 'text-grey'}`}>{lang.t('Book')}</span>
                  </div>
                  <div className="d-flex align-items-center flex-column" data-toggle="tooltip" title={lang.t('Listen audio')}>
                    <span className={`fw-lighter fs-6 ${hasAudioUrl ? 'text-chocolate' : 'text-grey'}`}>{lang.t('Listen Here')}</span>
                    <AiOutlineSound
                      size={60}
                      color={hasAudioUrl ? '#563636' : '#ccc'}
                      style={{ cursor: 'pointer' }}
                      className={`${isAllowedToListenAudio && isPlayingAudio && 'record-icon'}`}
                      onClick={() => isAllowedToListenAudio && audioPlayerRef.current.onPlayAndPauseHandler()}
                    />
                    <span className={`fw-lighter fs-6 ${hasAudioUrl ? 'text-chocolate' : 'text-grey'}`}>{lang.t('Audio')}</span>
                  </div>
                  <div className="d-flex align-items-center flex-column" data-toogle="tooltip" title={lang.t('Watch video')}>
                    <span className={`fw-lighter fs-6 ${hasVideoUrl ? 'text-chocolate' : 'text-grey'}`}>{lang.t('Watch Here')}</span>
                    <MdOndemandVideo size={60} color={hasVideoUrl ? '#563636' : '#ccc'} style={{ cursor: 'pointer' }} onClick={() => isAllowedToViewVideo && setOpenVideoModal(true)} />
                    <span className={`fw-lighter fs-6 ${hasVideoUrl ? 'text-chocolate' : 'text-grey'}`}>{lang.t('Video')}</span>
                  </div>
                </div>
                {user && user.id === userId ? (
                  <div className="d-flex justify-content-start flex-nowrap gap-2  pb-3">
                    <Button
                      animated="fade"
                      style={{ border: '2px solid #563636', borderRadius: 0, backgroundColor: '#563636', color: '#FFF', opacity: 1, width: '100%' }}
                      onClick={() => history.push(`/contents/${slug}/edit`)}
                    >
                      <Button.Content visible>
                        <div className="d-flex align-items-center flex-nowrap justify-content-center">
                          {/* <RiEditBoxLine color="#FFF" size={20} /> */}
                          <span className="fw-bold fs-6 text-white ms-2">{lang.t('Edit Content')}</span>
                        </div>
                      </Button.Content>
                      <Button.Content hidden>
                        <div className="d-flex align-items-center flex-nowrap justify-content-center">
                          <RiEditBoxLine color="#FFF" size={20} />
                          <span className="fw-bold fs-6 text-white ms-2">{lang.t('Edit Content')}</span>
                        </div>
                      </Button.Content>
                    </Button>

                    <Button
                      animated="fade"
                      style={{ border: '2px solid #563636', borderRadius: 0, backgroundColor: '#563636', color: '#FFF', opacity: 1, width: '100%' }}
                      onClick={() => setOpen(true)}
                    >
                      <Button.Content visible>
                        <div className="d-flex align-items-center flex-nowrap justify-content-center">
                          {/* <RiDeleteBin4Line color="#FFF" size={20} /> */}
                          <span className="fw-bold fs-6 text-white ms-2">{lang.t('Delete Content')}</span>
                        </div>
                      </Button.Content>
                      <Button.Content hidden>
                        <div className="d-flex align-items-center flex-nowrap justify-content-center">
                          <RiDeleteBin4Line color="#FFF" size={20} />
                          <span className="fw-bold fs-6 text-white ms-2">{lang.t('Delete Content')}</span>
                        </div>
                      </Button.Content>
                    </Button>
                  </div>
                ) : (
                  price !== 0 && (
                    <div className="d-flex justify-content-start flex-nowrap pb-3">
                      <Button
                        animated="fade"
                        style={{ border: '2px solid #563636', borderRadius: 0, backgroundColor: '#563636', color: '#FFF', opacity: 1, width: '100%' }}
                        onClick={() => onSubmitHandle()}
                      >
                        <Button.Content visible>{lang.t('Add To Cart')}</Button.Content>
                        <Button.Content hidden>
                          <Icon name="shop" />
                          +1
                        </Button.Content>
                      </Button>
                      <Button
                        animated="fade"
                        style={{ border: '2px solid #563636', borderRadius: 0, backgroundColor: '#563636', color: '#FFF', opacity: 1, width: '100%' }}
                        onClick={() => history.push(`/contents/${slug}/pay`)}
                      >
                        <Button.Content visible>{lang.t('Buy It Now')}</Button.Content>
                        <Button.Content hidden>
                          <Icon name="payment" />
                          {lang.t('Pay')}
                        </Button.Content>
                      </Button>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Other Content of Author */}
        {Boolean(books?.filter(book => book.slug !== props.match.params.slug).length) && (
          <div className="row mb-2">
            <div className="h5 p-3 shadow-sm">
              <div className="d-flex align-items-center justify-content-start flex-nowrap gap-2">
                {profile ? (
                  <Image src={profile} style={{ height: 60, width: 60, objectFit: 'cover', borderRadius: 15 }} circular />
                ) : (
                  <div className="p-2" style={{ borderRadius: 15, border: '1px solid #2F3640' }}>
                    <FaRegUserCircle color="#2F3640" size={40} />
                  </div>
                )}
                <div className="d-flex flex-column align-items-start justify-content-center gap-1">
                  <Link to={`/auth/profile/${username}`} className="fs-5 text-primary">
                    {username}
                  </Link>
                  <span className="fs-6 fw-bold" style={{ color: '#2F3640' }}>
                    {lang.t('Author Of This Book')}
                  </span>
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-start gap-5 p-3 flex-nowrap overflowX hide-scrollbar">
              {books
                ?.filter(book => book.slug !== props.match.params.slug)
                .slice(0, 15)
                .map((book, index) => {
                  return (
                    <Popup
                      key={book.slug}
                      trigger={
                        <motion.div whileHover={{ scale: 1.2 }} onClick={() => history.push(`/contents/${book.slug}`)} className="cursor-pointer">
                          <img src={book?.coverUrl ? book.coverUrl : DEFAULT_IMAGE} alt="content cover" style={{ width: 200, height: 240, objectFit: 'fill', borderRadius: 20 }} className="shadow" />
                        </motion.div>
                      }
                      content={
                        <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                          <img src={book?.coverUrl ? book.coverUrl : DEFAULT_IMAGE} alt="content cover" style={{ width: 200, height: 240, objectFit: 'fill' }} />
                          <span className="fw-bold fs-5 text-truncate text-center" style={{ width: 200 }}>
                            {book?.name}
                          </span>
                          <span className="text-orange-darken fw-bold fs-5">
                            {book?.price ? (
                              <span className="d-flex align-items-center">
                                <AiOutlineDollarCircle className="text-blue-darken me-1" size={30} />
                                <span className="text-blue-darken fw-bold fs-4">{book.price}</span>
                              </span>
                            ) : (
                              'Free'
                            )}
                          </span>
                        </div>
                      }
                      position="left center"
                    />
                  );
                })}
            </div>
          </div>
        )}

        {/*  Other Similar Contents */}
        <div className="row mb-5">
          <div className="h4 p-3 shadow-sm fw-bold text-blue-darken">{lang.t('Similar Books')}</div>
          <div className="col-lg-12 position-relative">
            {Boolean(approvedBooks?.getAllApprovedBooks?.edges?.length) && (
              <div className="col-lg-12 p-3 d-flex flex-nowrap gap-5 overflowX hide-scrollbar " ref={ArrowIconRef}>
                {React.Children.toArray(approvedBooks?.getAllApprovedBooks?.edges.slice(0, 31).map(book => <ContentCard book={book} onClickAddToCart={onClickAddToCart} />))}
              </div>
            )}
            {approvedBooks?.getAllApprovedBooks?.edges?.length > 35 && (
              <div className="col-lg-12 p-3 d-flex flex-nowrap gap-5 overflowX hide-scrollbar" ref={BottomArrowIconRef}>
                {React.Children.toArray(
                  approvedBooks?.getAllApprovedBooks?.edges
                    .filter(book => book.slug !== props.match.params.slug)
                    .slice(31)
                    .map(book => <ContentCard book={book} onClickAddToCart={onClickAddToCart} />),
                )}
              </div>
            )}

            <motion.div
              whileHover={{ scale: 1.1 }}
              className="bg-white position-absolute start-0 ms-2 cursor-pointer"
              style={{ top: '46%', zIndex: 99, borderRadius: '50%' }}
              data-toggle="tooltip"
              title="Previous"
              onClick={() => onPreviousHandler(ArrowIconRef, BottomArrowIconRef)}
            >
              <IoIosArrowDropleftCircle className="text-orange-darken" size={40} />
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.1 }}
              className="bg-white position-absolute end-0 me-2 cursor-pointer"
              data-toggle="tooltip"
              title="Next"
              style={{ top: '46%', zIndex: 99, borderRadius: '50%' }}
              onClick={() => onNextHandler(ArrowIconRef, BottomArrowIconRef)}
            >
              <IoIosArrowDroprightCircle className="text-orange-darken" size={40} />
            </motion.div>
          </div>
        </div>

        <div className="position-fixed bg-white shadow-lg top-50 start-0 p-3 d-flex flex-column" style={{ borderTopRightRadius: 10, borderBottomRightRadius: 10, zIndex: 30 }}>
          <motion.div className="mb-5" whileHover={{ scale: 1.5 }} data-toggle="tooltip" title={`${lang.t('Share via')} email`}>
            <RiMailSendLine size={25} onClick={() => mailClick(url)} className="cursor-pointer" />
          </motion.div>
          <motion.div className="mb-5" whileHover={{ scale: 1.5 }} data-toggle="tooltip" title={`${lang.t('Share via')} whatsapp`}>
            <RiWhatsappLine size={25} onClick={() => whatsappClick(url)} className="cursor-pointer" />
          </motion.div>
          <motion.div className="mb-5" whileHover={{ scale: 1.5 }} data-toggle="tooltip" title={`${lang.t('Share via')} facebook`}>
            <RiFacebookCircleLine size={25} onClick={() => facebookClick(url)} className="cursor-pointer" />
          </motion.div>
          <motion.div className="mb-0" whileHover={{ scale: 1.5 }} data-toggle="tooltip" title={`${lang.t('Share via')} twitter`}>
            <RiTwitterLine size={25} onClick={() => twitterClick(url)} className="cursor-pointer" />
          </motion.div>
        </div>
      </div>
      {/* end of container */}
      {isAllowedToListenAudio && <AudioPlayer setIsPlayingAudio={setIsPlayingAudio} audioUrl={audioUrl} ref={audioPlayerRef} />}
      <Footer />

      {isAllowedToReadBook && (
        <Modal centered={false} size="fullscreen" open={openBook} onClose={() => setOpenBook(false)} onOpen={() => setOpenBook(true)} style={{ minHeight: '60vh' }}>
          <div className="d-flex align-items-center justify-content-between p-3 bg-blue-darken m-0 shadow-sm">
            <span className="fw-bold fs-5 text-white"> {name}</span>
            <div data-toggle="tooltip" title="Close Video Player">
              <VscCloseAll className="text-white cursor-pointer" size={30} onClick={() => setOpenBook(false)} />
            </div>
          </div>
          {bookUrl?.endsWith('.epub') ? (
            <div style={{ position: 'relative', height: '100vh', width: '100%', overflowX: 'scroll', overflowY: 'hidden' }}>
              <ReactReader
                location={location}
                locationChanged={locationChanged}
                url={bookUrl}
              />
            </div>
          ) : (
            <DocViewer style={{ minHeight: '100vh' }} documents={[{ uri: bookUrl }]} pluginRenderers={DocViewerRenderers} config={{ header: { disableHeader: true, disableFileName: true } }} />
          )}
        </Modal>
      )}

      {open && (
        <Modal size="tiny" open={open} onClose={close} closeIcon>
          <Modal.Header>{lang.t('Do You Want To Delete This Book')}?</Modal.Header>
          <Modal.Content>
            <p style={{ color: 'black' }}>
              <b style={{ color: 'brown' }}>Note:</b> {lang.t('If you click on Delete Button, This Book will be deleted permanently')}!
            </p>
            <div>
              <Grid style={{ marginBottom: '20px', marginTop: '10px', outline: 'none' }}>
                <Grid.Column width={10}>
                  <Image style={{ width: '100%', outline: 'none' }} src={data && data.getOneBook.coverUrl !== '' ? data.getOneBook.coverUrl : DEFAULT_IMAGE} />
                </Grid.Column>
                <Grid.Column width={6} style={{ display: 'flex', outline: 'none', alignItems: 'center', justifyContent: 'center' }}>
                  <div style={{ outline: 'none', color: '#000' }}>
                    <p>
                      <Icon link name="user" size="large" />
                      <span>{data.getOneBook.author}</span>
                    </p>
                    <p>
                      <Icon link name="book" size="large" />
                      <span>{data.getOneBook.name}</span>
                    </p>
                  </div>
                </Grid.Column>
              </Grid>
            </div>
          </Modal.Content>
          <Modal.Actions>
            {DeleteLoading ? (
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="d-flex flex-column justify-content-center align-items-center flex-nowrap">
                      <Spinner />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <Button positive icon="trash" labelPosition="right" content={lang.t('Delete')} onClick={onClickDelete} style={{ backgroundColor: 'rgb(165, 25, 25)', opacity: 1 }} />
                <Button positive icon="cancel" labelPosition="right" content="Cancel" onClick={() => setOpen(false)} style={{ backgroundColor: 'gray', opacity: 1 }} />
              </>
            )}
          </Modal.Actions>
        </Modal>
      )}

      {/* ====ALL-related to  Report  Books======== */}
      {openReport && (
        <Modal size="tiny" open={setReportOpen} onClose={closeReport}>
          <Modal.Header>{lang.t('Report this Book')}?</Modal.Header>
          <Modal.Content>
            <p style={{ color: 'black' }}>
              <i className="info circle icon" style={{ color: 'brown' }} />
              {lang.t('Be patient, When a book is reported will be deleted in one day after final check up of Haapa Store admininistration')}.
            </p>

            <div>
              <TextArea
                label="Report description"
                name="description"
                type="text"
                value={values.description}
                onChange={onChangeHandle}
                style={{ minHeight: 200, width: '100%', padding: '10px' }}
                icon="copy"
              />
            </div>
          </Modal.Content>
          <Modal.Actions>
            {DeleteLoading ? (
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="d-flex flex-column justify-content-center align-items-center flex-nowrap">
                      <Spinner />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <Button positive icon="send" labelPosition="right" content={lang.t('Report')} onClick={() => onReportBook()} style={{ backgroundColor: 'rgb(165, 25, 25)', opacity: 1 }} />
                <Button positive icon="cancel" labelPosition="right" content="Cancel" onClick={() => setReportOpen(false)} style={{ backgroundColor: 'gray', opacity: 1 }} />
              </>
            )}
          </Modal.Actions>
        </Modal>
      )}
      {/* ====End-Of-Report   Modal */}

      {openRating && (
        <Modal size="tiny" open={setOpenRating} onClose={closeRating} closeIcon>
          <Modal.Header>{lang.t('Rate this content')}</Modal.Header>
          <Modal.Content>
            <div className="rating-book-main" style={{ textAlign: 'center' }}>
              {[...Array(5)].map((start, i) => {
                const ratingValue = i + 1;

                return (
                  <span key={i + 1}>
                    <label className="rating-book-label">
                      <input
                        type="radio"
                        name="ratingValue"
                        value={ratingValue}
                        onChange={onChangeRating}
                        onClick={() => setRating(ratingValue)}
                        className="rating-book-radio"
                        key={props.match.params.slug}
                      />

                      <Icon
                        name="star"
                        style={{ color: ratingValue <= (hover || rating) ? '#fd5a1f' : '#cacaca' }}
                        onMouseEnter={() => setHover(ratingValue)}
                        onMouseLeave={() => setHover(null)}
                        onClick={() => setRating(ratingValue)}
                      />
                    </label>
                  </span>
                );
              })}
              <p style={{ fontSize: '16px', marginTop: '10px' }}>
                {lang.t('Your rating is')} &nbsp;
                <b style={{ color: '#fd5a1f', textDecoration: 'underline' }}>{rating}</b>
                &nbsp;{lang.t('stars')}.
              </p>
              <TextArea
                label="Review"
                name="review"
                type="text"
                value={ratingValues.review}
                onChange={onChangeRating}
                style={{ minHeight: 100, width: '100%', padding: '10px' }}
                icon="copy"
                placeholder="Comment..."
              />
            </div>
          </Modal.Content>
          <Modal.Actions>
            {loadingRating ? (
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="d-flex flex-column justify-content-center align-items-center flex-nowrap">
                      <Spinner />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <Button positive content={lang.t('Cancel')} onClick={() => setOpenRating(false)} style={{ backgroundColor: 'gray', opacity: 1 }} />
                <Button primary content={lang.t('Submit')} onClick={() => ratingStar()} style={{ opacity: 1 }} />
              </>
            )}
          </Modal.Actions>
        </Modal>
      )}
      {/* ====End-Of- Rating Modal */}

      {openReview && (
        <Modal size="medium" open={setOpenReview} onClose={closeReview} closeIcon>
          <Modal.Header>{lang.t('All Reviews')}</Modal.Header>
          <Modal.Content>
            <div className="rating-book-main">
              {!loadingReviews && !errorReviews && getBookReviews.getBookReviews.length > 0 ? (
                <>
                  {getBookReviews &&
                    getBookReviews.getBookReviews.map((review, i) => (
                      <>
                        <div className="ui two column grid">
                          <div className="row">
                            <div className="column" style={{ width: '21%' }}>
                              {!review.user.profile ? <Image size="tiny" circular src={PROFILE_IMAGE} alt="user" /> : <Image size="tiny" circular src={review.user.profile} alt="user" />}
                            </div>

                            <div className="column" style={{ width: '78%' }}>
                              <h4>
                                <Link to={`/auth/profile/` + review.user.username}>{review.user.username}</Link>
                              </h4>
                              <p>
                                {[...Array(review.ratingValue)].map((str, indx) => {
                                  return (
                                    <span key={indx + 1}>
                                      <label key={indx + 1}>
                                        <Icon name="star" style={{ color: '#fd5a1f', fontSize: '14px' }} />
                                      </label>
                                    </span>
                                  );
                                })}
                                <small style={{ float: 'right', color: 'gray' }}>{moment(review.createdAt).fromNow()}</small>
                              </p>
                              <p style={{overflowX: 'scroll', textAlign: 'center', resize: 'both'}}>{review ? review.review : ''}</p>
                            </div>
                          </div>
                        </div>
                        <Divider />
                      </>
                    ))}
                </>
              ) : (
                <p> No review created</p>
              )}
            </div>
          </Modal.Content>
        </Modal>
      )}
      {/* ====End-Of- Rating Modal */}

      {openVideoModal && <VideoPlayer videoUrl={videoUrl} openVideoModal={openVideoModal} setOpenVideoModal={setOpenVideoModal} name={name} />}
    </>
  );
}

export default withTranslation()(SingleOneBook);
